import { IconCheck32, IconLinkExternal16 } from '@warp-ds/icons/react';
import { Box, Button } from '@warp-ds/react';
import { useState } from 'react';
import styles from '@/components/button/QasaPlatformSelectorButton.module.css';
import { useUnleash } from '@/hooks/unleash';
import { trackCreateOrRepublishAdButton, trackGoToQasaLandingPageFromPlatformSelector } from '@/utils/tracking';

type Props = {
    experiment: number;
    variant: string;
    itemId?: string;
};
export const QasaBox = ({ experiment, variant }: Props) => {
    const [loading, setLoading] = useState(false);
    const unleash = useUnleash();
    const experimentParams = unleash?.qasaExperimentParamsEnabled ? `?experiment=${experiment}&variant=${variant}` : '';
    const qasaNewAdUrl = `/travel-api/lotr/qasa/create-listing-landing${experimentParams}`;
    return (
        <Box bordered className="flex flex-col h-full !p-0">
            <div className="flex flex-col md:flex-row gap-16 md:gap-24 flex-1 px-16 pt-16 md:px-24 md:pt-24">
                <div className="flex-1 flex flex-col justify-between">
                    <div>
                        <div className="flex justify-between gap-16">
                            <div>
                                <div className="mb-24" aria-hidden>
                                    <img
                                        src="https://images.finncdn.no/dynamic/1280w/lotr/qasa/logo/qasalogo.png"
                                        alt="Qasa logo"
                                        width="178"
                                    />
                                </div>
                                <h2 className="h3 mb-8 flex items-center">Annonse på Qasa og FINN</h2>
                            </div>
                            <div className="flex-shrink-0">
                                <img
                                    src="https://images.finncdn.no/dynamic/1280w/lotr/qasa/ps-visual-qasa-finn.png"
                                    alt=""
                                    width={140}
                                    className="w-auto h-auto max-w-[140px]"
                                />
                            </div>
                        </div>
                        <p className="h4 mt-16 mb-8">Lei ut med Qasa. Den største tjenesten for utleie av boliger i Norden siden 2014.</p>
                        <div className="flex-col gap-16">
                            <div className="flex items-center gap-8 mb-4">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-caption">Annonse på Qasa og FINN</div>
                            </div>
                            <div className="flex items-center gap-8 mt-16 mb-4 font-bold">*Ved signering av Qasa leiekontrakt:</div>
                            <div className="flex items-center gap-8 mb-4">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-14">Leiegaranti - Alltid leie på konto i opptil 6 mnd</div>
                            </div>
                            <div className="flex items-center gap-8 mb-4">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-14">Utvidet forsikring mot eiendomsskader</div>
                            </div>
                            <div className="flex items-center gap-8 mb-4">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-14">Depositumsgaranti</div>
                            </div>
                            <div className="flex items-center gap-8 mb-4">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-14">Digital kontrakt med BankID signering</div>
                            </div>
                            <div className="flex items-center gap-8 mb-4">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-14">Automatisk fakturering av husleie</div>
                            </div>
                            <div className="flex items-center gap-8">
                                <IconCheck32 className="s-icon-positive flex-none" width={24} aria-hidden />
                                <div className="text-14">Varslinger til relevante interessenter</div>
                            </div>
                        </div>
                        <a
                            href="/realestate/lettings/qasa"
                            target="_blank"
                            className="text-14 block my-16 underline"
                            style={{ color: 'black' }}
                            onClick={() => {
                                trackGoToQasaLandingPageFromPlatformSelector();
                            }}
                            rel="noopener">
                            Les mer om alle fordelene med Qasa her
                        </a>
                    </div>
                    <div className="py-16">
                        <Box style={{ backgroundColor: '#FFF7FA' }}>
                            <p className="t4">Alle tjenester er gratis for deg som utleier!</p>
                        </Box>
                    </div>
                    <div className="mt-16">
                        <div className="mb-8">
                            <Button
                                className={styles.qasaButton}
                                onClick={() => {
                                    setLoading(true);
                                    trackCreateOrRepublishAdButton('qasa', null, true);
                                    setTimeout(() => {
                                        setLoading(false);
                                    }, 10000);
                                }}
                                fullWidth
                                primary={!loading}
                                loading={loading}
                                href={qasaNewAdUrl}>
                                <div className="flex items-center justify-center gap-8">
                                    Lei ut med Qasa
                                    <IconLinkExternal16 aria-hidden />
                                </div>
                            </Button>
                        </div>
                        <div className="text-14 min-h-[120px] md:min-h-[100px]">
                            <div>
                                <div className="mt-8">
                                    Annonse på Qasa og FINN koster 479 kr. *Ved signering av Qasa leiekontrakt betaler leietaker et
                                    servicegebyr på 4,98 % av månedsleien. Denne betalingen legges på den månedlige husleien og håndteres
                                    automatisk av Qasa.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-center py-8 mt-24 flex justify-center gap-8 rounded-b-8 min-h-[48]" style={{ backgroundColor: '#F0F0EB' }}>
                <div className="text-s mt-8">En del av</div>
                <img src="/realestate/lettings/icons/qasa/vend.svg" height="24px" width="61px" alt="Vend logo" />
            </div>
        </Box>
    );
};
